<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <logo />
        <h2 class="brand-text text-primary ml-1">
          {{ appName }}
        </h2>
      </b-link>

      <b-navbar-nav class="nav align-items-center ml-auto absolute-locale">
        <locale></locale>
      </b-navbar-nav>

      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img :src="imgUrl" fluid />
        </div>
      </b-col>

      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
          v-if="!isTokenExpired"
        >
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            {{ $t("resetPassword.title") }} 🔒
          </b-card-title>

          <validation-observer ref="resetPasswordForm" #default="{ invalid }">
            <b-form
              class="auth-reset-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <n-input :fields="fields" v-model="data"> </n-input>
              <n-button-loading
                type="submit"
                variant="primary"
                :loading="loading"
                :disabled="invalid"
                block
              >
                {{ $t("button.setNewPassword") }}
              </n-button-loading>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'login' }">
              <feather-icon icon="ChevronLeftIcon" />
              {{ $t("general.backToLogin") }}
            </b-link>
          </p>
        </b-col>
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto text-center" v-else>
          <b-img
            fluid
            :src="require('@/assets/images/icons/close.png')"
            class="w-25 mb-2"
          ></b-img>
          <b-card-title
            title-tag="h2"
            class="text-center font-weight-bold mb-1"
          >
            {{ $t("resetPassword.linkExpired") }}
          </b-card-title>
          <b-card-text class="text-center mb-2">
            {{ $t("resetPassword.linkExpiredDesc") }}
          </b-card-text>
          <p class="text-center mt-2">
            <b-link :to="{ name: 'login' }">
              <feather-icon icon="ChevronLeftIcon" />
              {{ $t("general.backToLogin") }}
            </b-link>
          </p>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Logo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BCardTitle,
  BCardText,
  BForm,
  BLink,
  BImg,
  BNavbarNav,
} from "bootstrap-vue";
import store from "@/store/index";
import { $themeConfig } from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormInput from "./resetPasswordFormInput";
import NInput from "@/components/NInput";
import NButtonLoading from "@/components/NButtonLoading";
import Locale from "@/layouts/components/app-navbar/Locale.vue";
import Repository from "@/repositories/RepositoryFactory";

const ForgotPasswordRepository = Repository.get("forgotPassword");

export default {
  components: {
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    BForm,
    BImg,
    BLink,
    BNavbarNav,
    Logo,
    Locale,
    NInput,
    NButtonLoading,
  },
  data() {
    return {
      data: {
        password: null,
        retypePassword: null,
      },
      loading: false,
      isTokenExpired: false,
      sideImg: require("@/assets/images/pages/reset-password-v2.svg"),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/reset-password-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
    token() {
      return this.$route.query.token;
    },
  },
  beforeMount() {
    if (!this.token) {
      this.$router.replace({ name: "login" });
    } else {
      this.checkToken();
    }
  },
  methods: {
    checkToken() {
      this.loading = true;
      ForgotPasswordRepository.checkForgotToken({ token: this.token })
        .then((response) => {
          const data = response?.data?.data;
          if (data.invalidToken) {
            this.$router.replace({ name: "login" });
          }

          if (data.tokenExpired) {
            this.isTokenExpired = true;
          }
        })
        .catch((error) => {})
        .then(() => {
          this.loading = false;
        });
    },
    validationForm() {
      this.$refs.resetPasswordForm.validate().then((success) => {
        if (success) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;

      ForgotPasswordRepository.resetPassword({
        ...this.data,
        token: this.token,
      })
        .then((response) => {
          this.$router.replace({ name: "login" }).then(() => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: this.$t("general.passwordReset"),
                icon: "CoffeeIcon",
                variant: "success",
                text: this.$t("alert.passwordResetResetSuccess"),
              },
            });
          });
        })
        .catch((error) => {})
        .then(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const { appName } = $themeConfig.app;
    const fields = FormInput;

    return {
      appName,
      fields,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
